import React, { useCallback, memo } from 'react';
import { useFormState } from 'react-final-form';
import { SwissSelect } from '../../../Fields/SwissSelect';

export const TableFilter = memo(({ onChange, ...props }) => {
    const { values } = useFormState();
    const wrappedOnChange = useCallback((...args) => {
        onChange(...args, values);
    }, [onChange, values]);

    return (
        <SwissSelect
            {...props}
            onChange={wrappedOnChange}
        />
    );
});
